import axios from 'axios';

const API_URL = 'https://ai.contextenglish.education';

export const registerUser = async (username) => {
  const res = await axios.post(`${API_URL}/register`, { username });
  return res.data.token;
};

export const createProject = async (token, projectName) => {
  const res = await axios.post(
    `${API_URL}/create-project`,
    { projectName },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const generateCode = async (token, projectName, prompt) => {
  const res = await axios.post(
    `${API_URL}/generate`,
    { projectName, prompt },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const getProjects = async (token) => {
  // optional backend endpoint to list user projects
  const res = await axios.get(`${API_URL}/projects`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};
